import { AdaSettings } from '@core/ada/models/ada-settings.interface';

export const adaNewMessageEventName = 'ada:conversation:message';

export interface AdaWindow extends Window {
  adaSettings?: AdaSettings;
  adaEmbed?: {
    setSensitiveMetaFields: (data: { accessToken: string }) => void;
    deleteHistory: () => void;
    stop: () => void;
    start: (settings: AdaSettings) => void;
    toggle: () => void;
    subscribeEvent: (eventName: typeof adaNewMessageEventName | string, callback: () => void) => Promise<number>;
    unsubscribeEvent: (subscriptionId: number) => void;
    reset: () => void;
  };
}
